module.exports = __webpack_public_path__ + "static/media/CNSA-formation-gestionnaire-de-cas-MAIA-mini.e401fde1.jpg";